import * as array from 'd3-array'
import * as scale from 'd3-scale'
import * as util from 'infographic-util'
import * as d3 from 'd3-selection'
import container from './container'
import gradients from './gradients'
import basicAnimation from './animations/basic-animation'

export const animations = [
  basicAnimation
]

const rads = degrees => {
  return degrees * (Math.PI / 180)
}

export const preAnimate = function (chart, selection, series) {
  let seriesData = series.selection().data()
    , dimensions = chart.datum().dimensions
    , grid = chart.layout.getGrid(dimensions)
    , config = chart.datum().axes.infographic
    , defs = d3.select(chart.node().ownerSVGElement).selectAll('defs')
    , colors = new Set

  // Determine the padding using the d3 internals.
  let paddingPercentage = .05
    , padScale = scale.scaleBand()
                      .domain([0, seriesData.length - 1])
                      .range([0, grid.height])
                      .paddingInner(paddingPercentage)
    , padding = padScale.step() - padScale.bandwidth()
    , totalHeight = grid.height - padding * (seriesData.length - 1)
    , totalWidth = (Math.tan(rads(30)) * totalHeight) * 2 // We want a 60deg internal angle triangle

  if (totalWidth > grid.width) {
    // Change the equation and calculate the height based on the width. This is a narrow widget
    totalWidth = grid.width
    totalHeight = (grid.width / 2) / Math.tan(rads(30))
  }

  // Determines the height of a slice based on its percentage of the pyramid
  let sliceY = percentage => {
    return Math.sqrt(totalWidth * totalWidth * percentage) * totalHeight / totalWidth
  }

  // Width of the pyramid is based on the bottom position
  let sliceWidth = (bottom, bottomN) => {
    return bottom / totalHeight * totalWidth
  }

  let pyramids = grid.blocks.map(block => {
    let points = util.getStackedPoints(config, totalHeight, block, seriesData, padding, sliceY, sliceWidth)

    points.forEach(point => colors.add(point.color))

    return {
      dimensions: {
        padding,
        width: totalWidth,
        height: totalHeight,
        center: grid.width / 2
      },
      block,
      padding,
      points
    }
  })

  // Add the gradients
  defs.call(gradients, chart.id, Array.from(colors), chart.defaultTransition)

  selection.call(container, chart, pyramids, config)
}
